exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".testimonials-container{background-color:#01112b;color:white;margin-bottom:2px}\n", ""]);
